import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/354b6cde-f378-42cf-a9dc-2356d64fa0ef/317478c1-082b-4ae3-9103-21d92ed78b63_Calm-Authority-1200-x-400-Transparent.svg?v=128148ac72e991491086eb8d499051ad';

export default function Footer() {
  const { t } = useTranslation('common');
  const location = useLocation();

  const handleFooterLinkClick = (event: React.MouseEvent<HTMLAnchorElement>, targetPath: string) => {
    if (location.pathname === targetPath) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="w-full">
      {/* Upper Footer */}
      <div className="bg-navy px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-10">
          {/* Brand Column */}
          <div className="flex flex-col gap-4">
            <div className="inline-block bg-white/95 rounded-lg px-4 py-2.5 self-start">
              <img
                src={LOGO_URL}
                alt="Calm Authority"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-seafoam text-sm leading-relaxed max-w-xs">
              {t('footer_tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col gap-4">
            <h4 className="text-white font-semibold text-base">{t('footer_quick_links')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" onClick={(event) => handleFooterLinkClick(event, '/')} className="text-seafoam text-sm hover:text-white transition-colors">{t('nav_home')}</Link>
              <Link to="/quiz" onClick={(event) => handleFooterLinkClick(event, '/quiz')} className="text-seafoam text-sm hover:text-white transition-colors">{t('nav_quiz')}</Link>
              <Link to="/decision-tree" onClick={(event) => handleFooterLinkClick(event, '/decision-tree')} className="text-seafoam text-sm hover:text-white transition-colors">{t('nav_decision_tree')}</Link>
              <Link to="/about" onClick={(event) => handleFooterLinkClick(event, '/about')} className="text-seafoam text-sm hover:text-white transition-colors">{t('nav_about')}</Link>
              <Link to="/contact" onClick={(event) => handleFooterLinkClick(event, '/contact')} className="text-seafoam text-sm hover:text-white transition-colors">{t('nav_contact')}</Link>
            </div>
          </div>

          {/* Resources */}
          <div className="flex flex-col gap-4">
            <h4 className="text-white font-semibold text-base">{t('footer_resources')}</h4>
            <div className="flex flex-col gap-2">
              <Link to="/quiz" onClick={(event) => handleFooterLinkClick(event, '/quiz')} className="text-seafoam text-sm hover:text-white transition-colors">Communication Quiz</Link>
              <Link to="/decision-tree" onClick={(event) => handleFooterLinkClick(event, '/decision-tree')} className="text-seafoam text-sm hover:text-white transition-colors">Decision Tree</Link>
              <a
                href="https://katiahunt.gumroad.com/l/scripts"
                target="_blank"
                rel="noopener noreferrer"
                className="text-seafoam text-sm hover:text-white transition-colors"
              >
                Script Pack
              </a>
              <a
                href="https://katiahunt.gumroad.com/l/course"
                target="_blank"
                rel="noopener noreferrer"
                className="text-seafoam text-sm hover:text-white transition-colors"
              >
                Course
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-4">
            <h4 className="text-white font-semibold text-base">{t('footer_contact')}</h4>
            <div className="flex flex-col gap-2">
              <a
                href="mailto:info@calm-authority.com"
                className="text-seafoam text-sm hover:text-white transition-colors"
              >
                info@calm-authority.com
              </a>
              <span className="text-seafoam text-sm">calm-authority.com</span>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="bg-teal px-4 md:px-8 lg:px-12 py-5">
        <p className="text-white text-sm text-center">
          {t('footer_copyright').replace('{year}', String(new Date().getFullYear()))}
        </p>
      </div>
    </footer>
  );
}